import React from 'react';
import ReactDOM from 'react-dom';

import FacebookProvider, { Page, Feed } from 'react-facebook';


export default class FacebookFeed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.screen.availWidth
        };
    }

    render() {
        return (
            <FacebookProvider appId="...">
                <Page href={this.props.facebookUrl} height={470} width={this.state.width} smallHeader={this.state.width < 768} />
            </FacebookProvider>);
    }
}
var root = document.getElementById('facebookFeed');
ReactDOM.render(<FacebookFeed {...(root.dataset) } />, root);


// WEBPACK FOOTER //
// ./Src/Home/FacebookFeed/FacebookFeed.jsx